import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import OverTheCounterTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditOverTheCounter from "./components/EditOverTheCounter";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddOverTheCounter from "./components/AddOverTheCounter";
import UploadCSV from "components/uploadCSV";
import SearchBox from "components/Filters/SearchBox";
import ShowModal from "components/Modal/ShowModal";
import { Tag } from "antd";

const Index = () => {
  const columns = [
    {
      title: "Name",
      render: (record) => <span>{record.otcName}</span>,
      key: "otcName",
    },

    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_OverTheCounter_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteOTC"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="overTheCounterList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this over the counter?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>Over The Counter</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654280924501-otcName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getOTC"
              recordName="overTheCounterList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getOTC"
              url="bulkImportSkills"
              table="OTC"
              recordName="overTheCounterList"
              cb="otcName"
              uId="overTheCounterId"
            />
            <AddOverTheCounter />
          </div>
        }
      >
        <OverTheCounterTable
          apiName="getOTC"
          recordName="overTheCounterList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditOverTheCounter />
    </Layout>
  );
};
export default Index;
